import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id1 = uuid();
    const id2 = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id1})`}>
                <rect width='24' height='24' rx='4' fill='#293BD9' />
                <g clipPath={`url(#${id2})`}>
                    <rect width='24' height='24' rx='4' fill='#293BD9' />
                    <rect x='4.6814' y='6.87585' width='16.0512' height='12.0384' fill='white' />
                    <path
                        d='M23.9457 1.24633C24.1526 1.45318 24.2698 1.73242 24.2698 2.02544V23.2856C24.2698 23.8958 23.7768 24.3888 23.1666 24.3888H1.10317C0.49298 24.3888 0 23.8958 0 23.2856V-5.39683C0 -6.00702 0.49298 -6.5 1.10317 -6.5H15.7443C16.0374 -6.5 16.32 -6.38279 16.5269 -6.17594L23.9457 1.24633ZM21.7256 2.53221L15.2376 -3.95581V2.53221H21.7256ZM12.1349 10.8094L13.9555 17.6008C13.979 17.6889 14.031 17.7667 14.1033 17.8222C14.1756 17.8777 14.2642 17.9077 14.3554 17.9077H15.4506C15.5417 17.9078 15.6302 17.8778 15.7025 17.8225C15.7748 17.7671 15.8268 17.6895 15.8505 17.6015L18.4143 8.08668C18.4236 8.05159 18.4283 8.01543 18.4281 7.97912C18.4281 7.86941 18.3845 7.76418 18.307 7.6866C18.2294 7.60902 18.1242 7.56543 18.0144 7.56543H16.7882C16.6946 7.56539 16.6037 7.59711 16.5304 7.65541C16.4572 7.71371 16.4058 7.79514 16.3849 7.88639L14.8066 14.7502L13.0912 7.8788C13.0688 7.78931 13.0172 7.70985 12.9445 7.65307C12.8718 7.5963 12.7822 7.56545 12.6899 7.56543H11.5798C11.4876 7.56547 11.3979 7.59636 11.3252 7.65321C11.2525 7.71006 11.2009 7.78959 11.1786 7.87915L9.46659 14.7364L7.87733 7.88604C7.85623 7.79504 7.80496 7.71385 7.73185 7.6557C7.65873 7.59755 7.56809 7.56586 7.47467 7.56578H6.25464C6.21843 7.56578 6.18239 7.57053 6.14742 7.57991C6.04152 7.60842 5.95127 7.67782 5.89651 7.77285C5.84176 7.86788 5.82698 7.98076 5.85543 8.08668L8.41237 17.6015C8.43601 17.6893 8.48793 17.7669 8.56009 17.8223C8.63226 17.8776 8.72064 17.9076 8.81158 17.9077H9.91441C10.0055 17.9076 10.094 17.8776 10.1663 17.8221C10.2385 17.7666 10.2904 17.6888 10.314 17.6008L12.1345 10.8094H12.1349Z'
                        fill='#293BD9'
                    />
                </g>
            </g>
            <defs>
                <clipPath id={id1}>
                    <rect width='24' height='24' rx='4' fill='white' />
                </clipPath>
                <clipPath id={id2}>
                    <rect width='24' height='24' rx='4' fill='white' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
